<kop-config [klantNo]="this.klantNo" (onInvalidKop)="this.onInvalidKop.emit($event)">
    <ng-content app-bar-menu>
    </ng-content>
</kop-config>
<div kendoDialogContainer></div>